(() => {
  const storageKey = 'pas.recentlyViewed';
  const section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  const current = section.dataset.currentHandle;
  const displayLimit = Math.min(4, Math.max(1, Number(section.dataset.displayLimit) || 4));
  const storageLimit = Math.max(displayLimit, Number(section.dataset.storageLimit) || 8);
  let handles = [];
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) handles = saved.filter((handle) => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle));
  } catch { /* Storage can be unavailable. */ }

  const recent = [...new Set(handles)].filter((handle) => handle !== current).slice(0, displayLimit);
  const next = [current, ...handles.filter((handle) => handle !== current)].filter(Boolean).slice(0, storageLimit);
  try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch { /* Storage can be unavailable. */ }

  if (!recent.length) return;
  const root = window.Shopify?.routes?.root || '/';
  const sectionId = section.dataset.sectionId;
  const grid = section.querySelector('[data-recently-viewed-grid]');

  Promise.all(recent.map(async (handle) => {
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`, { headers: { Accept: 'text/html' } });
      if (!response.ok) return null;
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      return page.querySelector('pas-product-card');
    } catch {
      return null;
    }
  })).then((cards) => {
    cards.filter(Boolean).forEach((card) => {
      const wrapper = document.createElement('div');
      wrapper.append(card);
      grid?.append(wrapper);
    });
    if (!grid?.querySelector('pas-product-card')) return;
    section.hidden = false;
    document.dispatchEvent(new CustomEvent('pas:cards-rendered'));
  });
})();
